<template>
  <app-card>
    <v-form v-model="formValidate">
      <v-container :class="{ 'pa-0': $vuetify.breakpoint.xsOnly }">
        <div class="pb-4">
          <v-row>
            <v-col cols="12">
              <v-autocomplete
                v-model="form.organization01"
                @input="onInput(1)"
                :items="organizationDropdown01"
                :loading="loadingDropdown01"
                :disabled="organizationDropdown01.length <= 1"
                label="เลือกหน่วยงาน"
                hide-details="auto"
                outlined
                dense
              />
            </v-col>
          </v-row>

          <v-row
            v-if="
              form.organization01 !== '' && organizationDropdown02.length > 0
            "
          >
            <v-col cols="12">
              <v-autocomplete
                v-model="form.organization02"
                @input="onInput(2)"
                :items="organizationDropdown02"
                :loading="loadingDropdown02"
                :disabled="organizationDropdown02.length <= 1"
                label="เลือกหน่วยงาน"
                hide-details="auto"
                outlined
                dense
              />
            </v-col>
          </v-row>

          <v-row
            v-if="
              form.organization02 !== '' && organizationDropdown03.length > 0
            "
          >
            <v-col cols="12">
              <v-autocomplete
                v-model="form.organization03"
                @input="onInput(3)"
                :items="organizationDropdown03"
                :loading="loadingDropdown03"
                :disabled="organizationDropdown03.length <= 1"
                label="เลือกหน่วยงาน"
                hide-details="auto"
                outlined
                dense
              />
            </v-col>
          </v-row>

          <v-row
            v-if="
              form.organization03 !== '' && organizationDropdown04.length > 0
            "
          >
            <v-col cols="12">
              <v-autocomplete
                v-model="form.organization04"
                :items="organizationDropdown04"
                :loading="loadingDropdown04"
                :disabled="organizationDropdown04.length <= 1"
                label="เลือกหน่วยงาน"
                hide-details="auto"
                outlined
                dense
              />
            </v-col>
          </v-row>
        </div>

        <v-row>
          <v-col cols="12" md="6">
            <v-select
              v-model="form.LeaveTypeID"
              :items="leaveTypeDropdown"
              menu-props="auto"
              label="ประเภท"
              hide-details="auto"
              outlined
              dense
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="6">
            <v-radio-group v-model="form.MonthChoice" hide-details="auto" row>
              <v-radio label="เดือนที่ลา" value="0" />
              <v-radio label="เดือนที่เขียนใบลา" value="1" />
            </v-radio-group>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="6">
            <v-select
              v-model="form.Month"
              :items="leaveMonthDropdown"
              menu-props="auto"
              label="เดือน"
              hide-details="auto"
              outlined
              dense
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="6">
            <v-select
              v-model="form.Year"
              :items="leaveYearDropdown"
              menu-props="auto"
              label="ปี"
              hide-details="auto"
              outlined
              dense
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="form.Keyword"
              label="ค้นหาจาก ชื่อ, สกุล หรือ รหัสใบลา"
              hide-details="auto"
              outlined
              dense
            />
          </v-col>
        </v-row>

        <v-row align="center">
          <v-col cols="auto">
            <v-btn
              @click="onSearch"
              color="primary darken-2"
              :disabled="!canSearch"
              depressed
              large
            >
              ค้นหา
            </v-btn>
          </v-col>
          <v-col cols="auto">
            <v-btn @click="onClear" color="secondary" depressed>
              ล้าง
            </v-btn>
          </v-col>
          <v-col></v-col>
        </v-row>
      </v-container>
    </v-form>
  </app-card>
</template>

<script>
export default {
  props: {
    page: {
      type: Number,
      default: 1
    }
  },

  data() {
    return {
      formValidate: null,
      form: {
        organization01: '',
        organization02: '',
        organization03: '',
        organization04: '',
        LeaveTypeID: '0',
        LeaveStatusID: 'A',
        MonthChoice: '0',
        Month: new Date().toISOString().substr(5, 2),
        Year: new Date().toISOString().substr(0, 4),
        Keyword: '',
        PageIndex: 0
      },
      leaveTypeDropdown: [],
      organizationDropdown01: [],
      organizationDropdown02: [],
      organizationDropdown03: [],
      organizationDropdown04: [],
      loadingDropdown01: false,
      loadingDropdown02: false,
      loadingDropdown03: false,
      loadingDropdown04: false
    }
  },

  computed: {
    leaveMonthDropdown() {
      return [
        {
          text: '---ไม่ระบุ---',
          value: '0'
        },
        {
          text: this.$lang === 'Tha' ? 'มกราคม' : 'January',
          value: '1'
        },
        {
          text: this.$lang === 'Tha' ? 'กุมภาพันธ์' : 'February',
          value: '2'
        },
        {
          text: this.$lang === 'Tha' ? 'มีนาคม' : 'March',
          value: '3'
        },
        {
          text: this.$lang === 'Tha' ? 'เมษายน' : 'April',
          value: '4'
        },
        {
          text: this.$lang === 'Tha' ? 'พฤษภาคม' : 'May',
          value: '5'
        },
        {
          text: this.$lang === 'Tha' ? 'มิถุนายน' : 'June',
          value: '6'
        },
        {
          text: this.$lang === 'Tha' ? 'กรกฎาคม' : 'July',
          value: '7'
        },
        {
          text: this.$lang === 'Tha' ? 'สิงหาคม' : 'August',
          value: '8'
        },
        {
          text: this.$lang === 'Tha' ? 'กันยายน' : 'September',
          value: '9'
        },
        {
          text: this.$lang === 'Tha' ? 'ตุลาคม' : 'October',
          value: '10'
        },
        {
          text: this.$lang === 'Tha' ? 'พฤศจิกายน' : 'November',
          value: '11'
        },
        {
          text: this.$lang === 'Tha' ? 'ธันวาคม' : 'December',
          value: '12'
        }
      ]
    },

    leaveYearDropdown() {
      const yearList = [
        {
          text: '---ไม่ระบุ---',
          value: '0'
        }
      ]
      const currentYear = parseInt(new Date().toISOString().substr(0, 4))
      const additionYear = this.$lang === 'Tha' ? 543 : 0
      for (let i = -10; i <= 1; i++) {
        yearList.push({
          text: currentYear + i + additionYear,
          value: (currentYear + i).toString()
        })
      }
      return yearList.reverse()
    },

    canSearch() {
      return (
        (this.form.organization01 !== '' && this.form.organization01 !== '0') ||
        this.form.Keyword != ''
      )
    }
  },

  watch: {
    $route() {
      this.setForm()
    },

    form: {
      handler(newVal) {
        for (let key in newVal) {
          if (newVal[key] === null || newVal[key] === undefined) {
            this.form[key] = ''
          }
        }
      },
      deep: true
    }
  },

  async mounted() {
    await this.setOrganization(1)
    this.leaveTypeDropdown = await this.apiGetFormTypeList()
    await this.setForm()
  },

  methods: {
    async setForm() {
      this.form = { ...this.form, ...this.$route.query }
      if (
        this.$route.query.organization01 &&
        this.$route.query.organization01 != 0
      ) {
        this.organizationDropdown01 = await this.apiGetOrganizationDropdown()
        this.organizationDropdown02 = await this.apiGetOrganizationDropdown(
          this.$route.query.organization01
        )
      }

      if (
        this.$route.query.organization02 &&
        this.$route.query.organization02 != 0
      ) {
        this.organizationDropdown03 = await this.apiGetOrganizationDropdown(
          this.$route.query.organization02
        )
      }

      if (
        this.$route.query.organization03 &&
        this.$route.query.organization03 != 0
      ) {
        this.organizationDropdown04 = await this.apiGetOrganizationDropdown(
          this.$route.query.organization03
        )
      }
    },

    onSearch() {
      if (this.form.organization04 && this.form.organization04 !== '0') {
        this.form.OrganizationId = this.form.organization04
      } else if (this.form.organization03 && this.form.organization03 !== '0') {
        this.form.OrganizationId = this.form.organization03
      } else if (this.form.organization02 && this.form.organization02 !== '0') {
        this.form.OrganizationId = this.form.organization02
      } else {
        this.form.OrganizationId = this.form.organization01
      }

      this.form.PageIndex = 0
      this.form.RowsPerPage = 10
      this.$router.push({ query: this.form }).catch(() => {
        console.log('same page, same result')
      })
    },

    async onClear() {
      this.form = {
        organization01: '',
        organization02: '',
        organization03: '',
        organization04: '',
        LeaveTypeID: '0',
        LeaveStatusID: 'A',
        MonthChoice: '0',
        Month: this.$dateFormat(new Date().toISOString().substr(5, 2), {
          format: 'M'
        }),
        Year: this.$dateFormat(new Date().toISOString().substr(0, 4), {
          format: 'YYYY'
        }),
        Keyword: '',
        PageIndex: 0
      }

      await this.setOrganization(1)

      this.$router.push({ query: {} }).catch(() => {
        console.log('same page, same result')
      })
    },

    async onInput(index) {
      let max = 4
      const parent = this.$zeroPrefix(index)

      if (this.form[`organization${parent}`]) {
        await this.setOrganization(
          index + 1,
          this.form[`organization${parent}`]
        )
      }

      for (max; max > index + 1; max--) {
        const i = this.$zeroPrefix(max)
        this.form[`organization${i}`] = ''
        if (
          max > index + 1 ||
          (max === index + 1 && !this.form[`organization${parent}`])
        )
          this[`organizationDropdown${i}`] = []
      }
    },

    async setOrganization(index, parent) {
      const target = this.$zeroPrefix(index)
      this[`loadingDropdown${target}`] = true
      const dropdown = await this.apiGetOrganizationDropdown(parent)

      this[`organizationDropdown${target}`] = dropdown
      this[`loadingDropdown${target}`] = false

      if (dropdown.length > 0) {
        this.form[`organization${target}`] = dropdown[0].value
        await this.setOrganization(index + 1, dropdown[0].value)
      } else {
        this.form[`organization${target}`] = ''
      }
    },

    async apiGetOrganizationDropdown(parent) {
      let extendPath = ''
      if (parent) extendPath = '/' + parent + '/child'
      try {
        const res = await this.$store.dispatch(
          'employee/getLeaveCheckerOrgDropdown',
          extendPath
        )
        return res
      } catch (e) {
        console.log(e.response || e)
        return []
      }
    },

    async apiGetFormTypeList() {
      try {
        const res = await this.$store.dispatch('leave/getFormTypeList')
        return (
          res.data.data.map(item => {
            return {
              value: item.leaveTypeID.toString(),
              text: item.leaveTypeNameTha
            }
          }) || []
        )
      } catch (e) {
        console.log(e.response || e)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
